import { Spinner } from "@blueprintjs/core";
import * as React from "react";

import Query from "core/api/QueryComponent";
import Class from "../util/Class";
import { IPanelProps } from "./Panel";

export interface IQueryOne<T, P> {
	queryEntity: T;
	queryParams: P;
}

type Params<T, configT> = (config: configT, pageParams: any, user: any) => T;

export function QueryOne<E, P, configT>(entity: Class<E>, params?: Params<P, configT>, withhold?: boolean): any {
	return (Panel: React.ComponentClass<IPanelProps<configT> & IQueryOne<E, P>>) => {

		return (props: IPanelProps<any>) => {

			// pass page params from the panel decorator down to the params function
			// TODO use panel context so decorators can be applied in any order on a react component?
			const queryParams = typeof params === "function" ? (pageParams: any, user: any) => params(props.config, pageParams, user) : params;

			return (
				<Query.One entity={entity} args={queryParams}>
					{(args) => {

						// if specified, do not render the panel until the data is loaded successfully
						if(withhold) {
							if (args.loading) {
								return <Spinner/>;
							}

							if (!args.data) {
								return "No Results";
							}
						}

						return <Panel {...props} queryParams={args.params} queryEntity={args.data}/>;
					}}
				</Query.One>
			);
		};
	};
}



// WEBPACK FOOTER //
// ./src/core/decorators/QueryOne.tsx